
<div class="SLV2-section-head-section" *ngIf="tabTopicData?.length > 0 || documentsData?.length >0">
    <div class="SLV2-section-heading-wrap" >
        <h3 class="SLV2-section-heading" *ngIf="tabTopicData?.length > 0">Curriculum</h3>
        <h4 class="SLV2-section-subheading" *ngIf="tabBannerData?.totalTopics">{{tabBannerData?.totalTopics}} topics, {{getDuration()}} Total Duration</h4>
    </div>
    <button class="SLV2-icon-with-text-btn" (click)="navigateToDocs()" *ngIf="documentsData?.length >0">
        <div class="SLV2-icon-wrap"><img src="selflearnv2-ui/assets/img/self-learn-v2/open-folder-icon.svg" /></div>
        <span>Doc's</span>
    </button>
</div>

<ol class="SLV2-chapter-topic-list" [ngClass]="{'expanded' : chapterViewMoreStatus}" *ngIf="tabTopicData?.length > 0">
    <li *ngFor="let topic of tabTopicData; let index = index">
        <app-topic-card (onExpandedRowIndex)="setExpandRowIndex($event)"
         [cardSubject]="tabSubject" [expandRowIndex]="expandRowIndex" [totalTopics]="tabTopicData.length"
         [rowIndex]="index" [topicData]="topic"></app-topic-card>
    </li>
</ol>
<!-- when there is no stories -->
<ng-container *ngIf="tabTopicData?.length <= 0">
    <app-no-content-card></app-no-content-card>
</ng-container>
<!-- end of when there is no stories -->
<!-- <div class="SLV2-section-action-area subject-section" *ngIf="tabTopicData?.length > 5">
    <button class="SLV2-subject-view-more-btn" [ngClass]="{'expanded' : chapterViewMoreStatus}"
        (click)="chapterViewMore()">
        <ng-container *ngIf="!chapterViewMoreStatus">view more</ng-container>
        <ng-container *ngIf="chapterViewMoreStatus">view less</ng-container>
        <img src="assets/img/profile-drop-down-arrow.svg" />
    </button>
</div> -->

